module.exports = __webpack_public_path__ + "static/myself-8ea0fd063bfdbab4bde4ddaf4e478610.jpg";